import React from 'react';
import MetricTiles from '../../../Elements/MetricTiles';
import MetricTileToneEnum from '../../../Enums/MetricTileToneEnum';

const tiles = [
  { label: 'Drafts to create', value: 1 },
  { label: 'Jobs to add', value: 5, note: 'on 2 drafts' },
  { label: 'Out of scope', value: 1, tone: MetricTileToneEnum.Warn },
  { label: 'Skipped', value: 0, tone: MetricTileToneEnum.Good },
];

function MetricTilesDemoComponent() {
  return <MetricTiles tiles={tiles} />;
}

export const metricTilesDemo = {
  id: 'metric-tiles',
  title: 'Metric tiles',
  category: 'Cards',
  importPath: 'Elements/MetricTiles',
  notes: [
    'Numbers that sum something up: a small capitals label over a big number, and a line under it when there is one.',
    'tiles are { label, value, note, tone }; tone is a MetricTileToneEnum value: Plain (the default), Good (green) or Warn (amber).',
    'The tiles share the row and wrap onto the next one when it gets narrow.',
  ],
  snippet:
    '<MetricTiles\n  tiles={[{ label: "Jobs to add", value: 5 }, { label: "Skipped", value: 0, tone: MetricTileToneEnum.Good }]}\n/>',
  render: MetricTilesDemoComponent,
};
